module.exports = __webpack_public_path__ + "static/szklanki@2x-2ad62d54bb5f488039695d669c39189e.png";